import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn} from "typeorm"

@Entity("go_cardless_transaction")
export class GoCardlessTransaction {

    @PrimaryGeneratedColumn()
    id?: number
    
    @Column() 
    url?: string

    @Column({ default: false })
    paidStatus?: boolean

    @Column()
    billingId?: string

    @Column()
    customerId?: string

    @CreateDateColumn()
    createdAt?: Date

    @UpdateDateColumn()
    updatedAt?: Date

    @Column({ nullable: false })
    amount?: number
    
}
